export function drag(
  definition,
  status,
  currentItemView,
  methods,
) {
  if (status !== 'drag') return false
  if (!methods.getItem) return false

  //user's end callback
  const onDragEnd = definition.onDragEnd
  if (onDragEnd) onDragEnd(methods.getItem(currentItemView))
  else return false

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseUp/drag.js